export default __webpack_public_path__ + "static/Household-Junk-Dumpsters-09268b343bd19b1ae4544345176c7e70.jpg";